import React, { useContext } from 'react'
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment-timezone';
import 'moment-duration-format';
import styles from '../../styles/Conversations.module.css'
import { SubscriptionConversationProps } from '../../types/interface'
import { URL } from '../../constants';
import FlagBadge from '../Common/FlagBadge';
import DurationBadge from '../Common/DurationBadge';
import MediaTypeBadge from '../Common/MediaTypeBadge';
import CxTopicBadge from '../Common/CxTopicBadge';
import { AuthContext } from '../../store/auth-context';
import Ratings from '../Common/Ratings';
import { getCookie } from '../../utils/common';


const Conversations = ({conversations, filters, uuid}: SubscriptionConversationProps) => {

    const authCtx = useContext(AuthContext)
    const tenantSlug = getCookie('current_tenant')

    const keywordsParams = filters.keywords && filters.keywords.length && encodeURIComponent(filters.keywords.join())

    const conversationsUI = conversations.map((conversation: {[key: string]: any}, i) => {
        let totalDuration = conversation[`x_ssense_call_duration_v1`] || ''

        let conversationLabeling = `x_ssense_labels_called_out_v1`
        let cxTopic = conversation?.labelling_analysis?.[conversationLabeling][`x_ssense_conversationcxtopic_v1`] || ''
        

        let sessionId = conversation.session_id ? `?session_id=${conversation.session_id}` : ''
        let queryParams = keywordsParams ? `?keywords=${keywordsParams}&search_subscription=${uuid}` : `?search_subscription=${uuid}`
        let agentName = conversation?.agent_customer_identification_service_output?.data?.agent?.name || ''
        let fileName = agentName ? `${agentName}_${conversation.thread_id}` : conversation.thread_id

        // converting unix time stamp to time
        let createdAt = conversation?.date || ''

        let flags = {
            customerEscalation: conversation[`x_ssense_thread_escalated_v1`],
            durationAHT: conversation[`x_ssense_flag_callduration_v1`],
            excessiveHold: conversation[`x_ssense_flag_customerhold_v1`],
            agentSkippedIntro: conversation[`x_ssense_agent_skip_intro_flag_v1`],
            agentSkippedSalutation: conversation[`x_ssense_agent_skipped_salutation_detected_v1`],
            agentProfanity: conversation[`x_ssense_agent_profanity_detected_v1`],
            customerProfanity: conversation[`x_ssense_customer_profanity_detected_v1`],
            agentDecliningSentiment: conversation[`x_ssense_agent_declining_sentiment_v1`],
            customerDecliningSentiment: conversation[`x_ssense_customer_declining_sentiment_v1`],
            customerToneFrustrated: conversation[`x_ssense_customer_tone_frustrated_detected_v1`],
            customerToneImpolite: conversation[`x_ssense_customer_tone_impolite_detected_v1`],
            customerToneSad: conversation[`x_ssense_customer_tone_sad_detected_v1`],
            agentToneFrustrated: conversation[`x_ssense_agent_tone_frustrated_detected_v1`],
            agentToneImpolite: conversation[`x_ssense_agent_tone_impolite_detected_v1`],
        }

        return  <div key={`conversation-${conversation.hash_id}`} className={`${styles.conversationBlock} hover-effect bg-white p-4 mt-3`}>
                    <Link to={`/${authCtx.currentTenant}/${URL.conversation}/${conversation.thread_id}${sessionId}`} className="text-decoration-none">
                        <div className="d-flex align-items-center justify-content-between mb-2">
                                <h5 className="mb-0 me-2 text-truncate" title={fileName}>{fileName}</h5>
                                <div className="d-flex align-items-center">
                                    <MediaTypeBadge type={conversation.communication_mode} />
                                    {
                                        (totalDuration && conversation.session_id != 'null') && 
                                        <DurationBadge 
                                            totalDuration={totalDuration}
                                        />
                                    }
                                </div>
                        </div>
                        <small className="my-2">{moment.tz(createdAt, "UTC").format('MMMM D, YYYY  h:mm A z')}</small>
                        {
                            cxTopic && (cxTopic.toLowerCase() != 'none' ? <CxTopicBadge topic={cxTopic} /> : null )
                        }
                        <div className="d-flex align-items-center justify-content-end">
                            {
                                <Ratings
                                    avgQAScore={conversation?.qa_automated_score}
                                />
                            }
                        </div>
                    </Link>
                </div>
    })

    return (
        <div>
            {conversations.length && conversationsUI}
        </div>
    )
}

export default Conversations
